/**
 * Word List Management Types
 *
 * TypeScript interfaces for word list management
 */

export interface WordList {
  id: string;
  name: string;
  description: string | null;
  type: string;
  languageCode: string;
  skillLevelId: number;
  wordCount: number;
  thumbnailUrl: string | null;
  order: number;
  isPublished: boolean;
  createdAt: string;
  updatedAt: string;
  learningGoalIds: number[];
}

export interface WordListListResponse {
  items: WordList[];
  total: number;
  page: number;
  pageSize: number;
}

export interface WordListCreateRequest {
  name: string;
  description?: string;
  type: string;
  language_code: string;
  skill_level_id: number;
  thumbnail_url?: string;
}

export interface WordListUpdateRequest {
  name?: string;
  description?: string;
  type?: string;
  skill_level_id?: number;
  thumbnail_url?: string;
}

export interface WordListReorderRequest {
  list_ids: string[];
}

export interface LearningGoalsAssignRequest {
  learning_goal_ids: number[];
}

export interface PublishRequest {
  is_published: boolean;
}

// API response to frontend type mapping
export interface WordListApiResponse {
  id: string;
  name: string;
  description: string | null;
  type: string;
  language_code: string;
  skill_level_id: number;
  word_count: number;
  thumbnail_url: string | null;
  order: number;
  is_published: boolean;
  created_at: string;
  updated_at: string;
  learning_goal_ids: number[];
}

export interface WordListListApiResponse {
  items: WordListApiResponse[];
  total: number;
  page: number;
  page_size: number;
}

/**
 * Convert API response to frontend type
 */
export function mapWordListFromApi(api: WordListApiResponse): WordList {
  return {
    id: api.id,
    name: api.name,
    description: api.description,
    type: api.type,
    languageCode: api.language_code,
    skillLevelId: api.skill_level_id,
    wordCount: api.word_count,
    thumbnailUrl: api.thumbnail_url,
    order: api.order,
    isPublished: api.is_published,
    createdAt: api.created_at,
    updatedAt: api.updated_at,
    learningGoalIds: api.learning_goal_ids,
  };
}
